import React from 'react';

import ModelTypeConstants from 'constants/ModelTypeConstants';
import {getSharedSmartChipProps, SharedSmartChipProps} from 'ui-library/chips/ChipUtil';
import {getSecondaryText} from 'ui-library/chips/EntryChip';
import SmartChip from 'ui-library/chips/SmartChip';
import useSmartChipQuery, {SmartChipType} from 'ui-library/chips/useSmartChipQuery';

export interface BulkAssemblyChipProps extends SharedSmartChipProps<SmartChipType.BULK_ASSEMBLY> {
  id: string;
}

export default function BulkAssemblyChip(props: BulkAssemblyChipProps): JSX.Element {
  const sharedSmartChipProps = getSharedSmartChipProps(props);
  const {id, onClick} = sharedSmartChipProps;

  const {
    item: bulkAssembly,
    handleClickLink,
    isInaccessible,
    itemUrl,
  } = useSmartChipQuery<SmartChipType.BULK_ASSEMBLY>({
    id,
    onClick,
    getUrlFn: ({editUrl}) => editUrl,
  });

  return (
    <SmartChip
      {...sharedSmartChipProps}
      icon={ModelTypeConstants.BULK_ASSEMBLY}
      isInaccessible={isInaccessible}
      item={bulkAssembly}
      onClick={handleClickLink}
      url={itemUrl}
      getSecondaryText={getSecondaryText}
    />
  );
}
